import PropTypes from 'prop-types';

const HourglassIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.3468718,42.6809091 L38.1375059,42.6809091 C38.0428572,33.7834395 33.7272959,26.3173809 27.8581919,24 C33.7275927,21.6826191 38.0428572,14.2165605 38.1375059,5.31909093 L39.3468718,5.31909093 C40.8122935,5.31909093 42,4.12828075 42,2.65939676 C42,1.19051278 40.8122935,0 39.3468718,0 L8.65342489,0 C7.18800327,0 6,1.19051278 6,2.65939676 C6,4.12828075 7.18800327,5.31909093 8.65342489,5.31909093 L9.86249412,5.31909093 C9.95743944,14.2165605 14.2727041,21.6826191 20.1418081,24 C14.2727041,26.3173809 9.95743944,33.7834395 9.86249412,42.6809091 L8.65342489,42.6809091 C7.18800327,42.6809091 6,43.8717193 6,45.3406033 C6,46.8091898 7.18800327,48 8.65342489,48 L39.3468718,48 C40.8122935,48 42,46.8091898 42,45.3406033 C42,43.8717193 40.8122935,42.6809091 39.3468718,42.6809091"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

HourglassIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

HourglassIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default HourglassIcon;
